import {View} from 'react-native';
import React from 'react';
import IconButton from '../IconButton';
import TextButton from '../TextButton';
import {useTheme} from '../../../theme';
import styles from './styles';
import {DLog} from '../../../utils/HelperMethods';
import {LeftArrowIcon, RightArrowIcon} from '../../../utils/SvgIcons';

const PageView = ({
  pageCount = 4,
  currentIndex = 1,
  onPressPage,
  onPressPrevious,
  onPressNext,
}) => {
  const {colors} = useTheme();
  const onPressPageNumber = number => {
    const num = parseInt(number);
    if (!Number.isNaN(num) && num != currentIndex) {
      onPressPage(num);
    }
  };

  const renderPageCounts = () => {
    if (pageCount > 5) {
      const tempArray = Array(5).fill(1);
      return tempArray.map((item, index) => {
        let startIndex = 1;
        if (currentIndex > 1) {
          startIndex = currentIndex - 1;
        }
        let title = startIndex + index;

        if (title > pageCount - 5 && currentIndex > pageCount - 3) {
          title = 1;
          if (index == 1) {
            title = '...';
          } else if (index > 1) {
            title = pageCount - (4 - index);
          }
        } else {
          if (index == 3) {
            title = '...';
          } else if (index > 3) {
            title = pageCount;
          }
        }
        return (
          <TextButton
            key={index}
            title={`${title}`}
            selected={title === currentIndex}
            onPress={() => onPressPageNumber(title)}
          />
        );
      });
    } else {
      const tempArray = Array(pageCount).fill(1);
      return tempArray.map((item, index) => (
        <TextButton
          key={index}
          title={`${index + 1}`}
          selected={index + 1 === currentIndex}
          onPress={() => onPressPageNumber(`${index + 1}`)}
        />
      ));
    }
  };

  return (
    <View style={styles.container}>
      <IconButton
        disabled={currentIndex == 1}
        tintColor={currentIndex == 1 ? colors.borderMuted : colors.textPrimary}
        leftImage={<LeftArrowIcon />}
        buttonSize={32}
        imageSize={10}
        onPress={onPressPrevious}
      />
      {renderPageCounts()}
      <IconButton
        disabled={currentIndex == pageCount}
        tintColor={
          currentIndex == pageCount ? colors.borderMuted : colors.textPrimary
        }
        leftImage={<RightArrowIcon />}
        buttonSize={32}
        imageSize={10}
        onPress={onPressNext}
      />
    </View>
  );
};

export default PageView;
